import { getTenantLegacyId } from "../api/tenantContext";

/** 现场签到码 H5（二维码 + 实时签到昵称）的绝对 URL；新窗口打开供平板/手机展示。 */
export function buildActivityCheckinPublicUrl(activityId: string, tenantLegacyId?: string): string {
  const tid = tenantLegacyId ?? getTenantLegacyId();
  const rawBase = import.meta.env.BASE_URL || "/";
  const normalizedBase = rawBase === "/" ? "" : rawBase.replace(/\/$/, "");
  const path = `${normalizedBase}/activity-checkin/${encodeURIComponent(activityId)}?tenant=${encodeURIComponent(tid)}`;
  return new URL(path.startsWith("/") ? path : `/${path}`, window.location.origin).href;
}

export function openActivityCheckinScreen(activityId: string, tenantLegacyId?: string): void {
  window.open(buildActivityCheckinPublicUrl(activityId, tenantLegacyId), "_blank", "noopener,noreferrer");
}

/** 复制现场签到 H5 地址；失败时返回 false（如无剪贴板权限）。 */
export async function copyActivityCheckinPublicUrl(activityId: string, tenantLegacyId?: string): Promise<boolean> {
  const url = buildActivityCheckinPublicUrl(activityId, tenantLegacyId);
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
